import { defaultClient } from "../client/consts";
import { defaultService } from "../services/consts";
import { ClientServices } from "./types/client_services";



export enum TypesServices {
    PAID = 0,
    BONUS = 1
}

export enum Recurrent {
    SIM = 0,
    NAO = 1
}

export enum FormMode {
    Add = "add",
    Edit = "edit",
    View = "view",
}

export enum ServiceSize {
    P = "P",
    M = "M",
    G = "G"
}

export const getSizeLabel = (size: string | undefined | null, sizeUnit?: string | null): string => {
    if (!size) return '';
    switch (size) {
        case 'P':
            return 'Pequeno';
        case 'M':
            return 'Médio';
        case 'G':
            return 'Grande';
        default:
            if (sizeUnit) {
                return `${size} ${sizeUnit}`;
            }
            return size;
    }
};



export const defaultClientServices: ClientServices = {
    id: '',
    type: 1,
    period: 0,
    firstDate: new Date(),
    lastDate: new Date(),
    recurrent: true,
    recurrencePeriod: 1,
    createdAt: new Date(),
    createdBy: '',
    updatedAt: null,
    updatedBy: null,
    clientId: '',
    serviceId: '',
    services: [],
    client: defaultClient,
    service: defaultService,
    quantity: undefined,
    executionTime: undefined,
    size: undefined,
    sizeUnit: undefined,
    observations: undefined
}